import { Divider, Group, Stack, Text, useMantineTheme, Box } from '@mantine/core';

import OpportunityAssessmentList from './OpportunityAssessmentList';
import OpportunityEvaluator from './OpportunityEvaluator';

const OpportunityEvaluations: React.FC = () => {
  const { other: colorVars, colors } = useMantineTheme();
  const titleGroup = <Stack gap={8}>
    <Text fw={500} fz={18}>
      Opportunity Evaluator
    </Text>
    <Text fz='sm' c={colorVars.secondaryTextColor}>
      Import the opportunity and click Evaluate for a bid/no-bid recommendation with justification.
    </Text>
  </Stack>;

  return (
    <Stack flex={1} gap='md' h='100%'>
      {titleGroup}
      <Group gap={0} flex={1} >
        <Box h='100%' w='33%' >
          <OpportunityEvaluator />
        </Box>
        <Divider orientation="vertical" pr={16} color={colors.gray[4]} />
        <OpportunityAssessmentList />
      </Group>
    </Stack>
  );
};

export default OpportunityEvaluations;
